import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fototeca',
  templateUrl: './fototeca.component.html',
  styleUrls: ['./fototeca.component.css']
})
export class FototecaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
